import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutModule } from '../../../layouts/layout.module';

import { BlockUIModule } from 'ng-block-ui';
import { SweetAlert2Module } from '@toverux/ngx-sweetalert2';

import { ConfigsRoutingModule } from './configs-routing.module';
import { ConfigsListComponent } from './configs-list/configs-list.component';
import { ConfigsDeadlineInvoiceComponent } from './configs-deadlineinvoice/configs-deadline-invoice.component';
import { ConfigsDeadlineModalComponent } from './configs-modals/deadline-modal/configs-deadline-modal.component';
import { ConfigsCategoriesComponent } from './configs-categories/configs-categories.component';
import { ConfigsTypesUnitComponent } from './configs-types-unit/configs-types-unit.component';
import { ConfigsCategoryModalComponent } from './configs-modals/category-modal/configs-category-modal.component';
import { ConfigsCategoryCreateModalComponent } from './configs-modals/category-create-modal/configs-category-create-modal.component';
import { ConfigsInvestorDocumentsComponent } from './configs-investor-documents/configs-investor-documents.component';
import { ConfigsInvestorDocumentCreateModalComponent } from './configs-modals/investor-document-create-modal/configs-investor-document-create-modal.component';
import { ConfigsTypesUnitCreateModalComponent } from './configs-modals/types-unit-create-modal/configs-types-unit-create-modal.component';
import { TableModule } from '../../../../shared/table';
import { ApiModule } from '../../../../_services/api.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigsInvestorDocumentModalComponent } from "./configs-modals/investor-document-modal/configs-investor-document-modal.component";
import { TypeUnitProviders } from "../../../../_models";
import { ConfigsTypeUnitModalComponent } from "./configs-modals/types-unit-modal/configs-type-unit-modal.component";

@NgModule({
    imports: [
        CommonModule,
        ConfigsRoutingModule,
        LayoutModule,
        TableModule,
        BlockUIModule.forRoot(),
        SweetAlert2Module.forRoot(),
        ApiModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule,
        NgbModule.forRoot(),
    ],
    providers: [NgbActiveModal, TypeUnitProviders],
    declarations: [ConfigsListComponent,
        ConfigsDeadlineInvoiceComponent,
        ConfigsDeadlineModalComponent,
        ConfigsCategoriesComponent,
        ConfigsTypesUnitComponent,
        ConfigsCategoryModalComponent,
        ConfigsCategoryCreateModalComponent,
        ConfigsInvestorDocumentsComponent,
        ConfigsInvestorDocumentCreateModalComponent,
        ConfigsTypesUnitCreateModalComponent,
        ConfigsInvestorDocumentModalComponent,
        ConfigsTypeUnitModalComponent]
})
export class ConfigsModule { }



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/configs/configs.module.ts